// @flow
import $ from 'jquery';
import '../webActions/hsExpand/highslide-settings.js';

/**
 * Custom highslide';

 */
export default (): void => {

  window.openVideo = function (ts) {
      return hs.htmlExpand(ts, {
        objectType: 'iframe',
        allowWidthReduction: true,
        width: 960,
        height: 540,
        captionEval: null,
        allowfullscreen: true,
        contentId: 'videoBlock',
        wrapperClassName: 'video-block'
      });
  };
  $(function () {
    $('.hsIframe').on('click', function (e) {
    	e.preventDefault();
      window.openVideo(this);
    });
  });

};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/customHighslide.js